<template>
    <nav class="panel bottom font-body fixed left-0 w-full z-50 text-center text-size2 pointer-events-none bottom-0 w-5 m-auto">
        <div class="sections">
            <div class="center">
                <p class="address text-size11 font-anonymouse opacity-100 pb-spc24" v-if="title">{{title}}</p>
                <p class="address text-size11 font-anonymouse opacity-100 pb-spc24 mb-spc1" v-if="copyright">{{copyright}} <a :href="[developerUrl ? (developerUrl) : '#']" target="_blank" class="hover:opacity-75">{{developeby}}</a></p>
                <span class="toFirstSlide block hover:opacity-100 cursor-pointer">
                    <svg id="arrow-up" viewBox="0 0 24 24"  class="w-5 ml-auto mr-auto hover:opacity-100 hover:cursor-pointer">
                        <path d="M11.9 5.9c.2 0 .5.1.7.3l11 10c.4.4.4 1 .1 1.4-.4.4-1 .4-1.4.1l-10.4-9.4-10.3 9.4c-.4.4-1 .3-1.4-.1-.4-.4-.3-1 .1-1.4l11-10c.1-.2.4-.3.6-.3z"></path>
                    </svg>
                </span>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "PrevButton",
        props: [
            'title',
            'copyright',
            'developeby',
            'developerUrl',
        ]
    }
</script>

<style scoped>

</style>